// https://www.userflow.com/home
// https://docs.userflow.com/docs/userflow-js#userflow-js-reference
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import userflow from 'userflow.js'
import store from '@/store/store'

export function userflowLogin() {

  if (!process.env.VUE_APP_USERFLOW_TOKEN) {
    return
  }

  userflow.init(process.env.VUE_APP_USERFLOW_TOKEN)

  const {
    ccNavision,
    companyId,
    companyName,
    id,
    email,
    isDocsIAUser,
    product,
    productId,
    subscription,
    LexonType,
    userId
  } = store.getters[`${ModuleNamespaces.AUTH}/getTrackUser`]

  const parseSubscriptionFlags = (subscriptionArr: number[]): Record<string, boolean> => {
    return subscriptionArr.reduce((acc, subId) => {
      acc[`hasSub_${subId}`] = true;
      return acc;
    }, {} as Record<string, boolean>);
  }

  userflow.identify(
    userId,
    {
      userEmail: email,
      isDocsIAUser,
      product,
      productId,
      userInLexON: id,
      LexonType,
      ...parseSubscriptionFlags(subscription)
    }
  )

  userflow.group(
    companyId,
    {
      ccNavision,
      companyId,
      companyName,
    }
  )
}

export function userflowLogout() {
  userflow.reset()
}